<script>
export default {
  name: "examineSetting",
  data() {
    return {
      form: {
        config: []
      },
      loading:false
    }

  },
  mounted() {
    this.getInitFn()
  },
  methods: {
    async getInitFn() {
      const url = '/api/v1/manage/withdrawal/check/mode'
      const {code, data} = await this.$axios.get(url)
      if (code === 1) {
        const list = data.map(item => ({...item, checkMode: item.checkMode || 1}))
        this.$set(this.form, 'config', list || [])
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          const url = '/api/v1/manage/withdrawal/check/mode'
          const {code} = await this.$axios.post(url, {
            withdrawalCheckModeJson: JSON.stringify(this.form.config)
          })
          this.loading = false
          if (code === 1) {
            this.$message.success('操作成功')
            this.$emit('handClose')
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<template>
  <div class="examineSetting">
    <el-form label-position="left" :model="form" ref="form" label-width="180px">
      <el-form-item
          v-for="(domain, index) in form.config"
          :label="domain.organizationName"
          :key="index"
      >
        <el-radio-group v-model="domain.checkMode">
          <el-radio :label="1">人工通过审核</el-radio>
          <el-radio :label="2">自动通过审核</el-radio>
        </el-radio-group>

      </el-form-item>
      <p class="util-money">注意：开启自动通过审核，发起提现后即自动审核通过并转账</p>

      <el-form-item>
        <div class="flex-end">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button :loading="loading" type="primary" @click="submitForm">提交</el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<style scoped lang="less">

</style>